import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((theme, { verticalClickArea }, classes)=>({
        input: {
            marginRight: theme.spacing(0.9),
            marginLeft: theme.spacing(0.9),
            padding: 0,
            '&:hover:not(.Mui-disabled)': {
                [`& .${classes.iconChecked} > .vkuiIcon path`]: {
                    fill: theme.tokens.colors.original.brand.tertirary
                },
                [`& .${classes.iconUnchecked} > .vkuiIcon path`]: {
                    fill: theme.tokens.colors.stroke.secondary
                }
            },
            '&.Mui-disabled': {
                backgroundColor: 'transparent',
                '&:not(.Mui-checked, .MuiCheckbox-indeterminate)': {
                    backgroundColor: theme.tokens.colors.bg.light.primary
                },
                '& .vkuiIcon path': {
                    fill: theme.tokens.colors.bg.greyscale.primary
                },
                '&.Mui-checked': {
                    [`& .${classes.iconChecked}`]: {
                        position: 'relative',
                        background: `conic-gradient(${theme.tokens.colors.stroke.secondary} 0 0) no-repeat center / 70% 50%`
                    }
                },
                [`& .${classes.iconChecked}:after`]: {
                    background: theme.tokens.colors.stroke.secondary
                }
            }
        },
        sizeDefault: {
            width: 18,
            height: 18
        },
        sizeLarge: {
            width: 42,
            height: 42
        },
        verticalClickArea: {
            marginTop: verticalClickArea,
            marginBottom: verticalClickArea
        },
        iconUnchecked: {},
        iconChecked: {
            '&:after': {
                content: '" "',
                position: 'absolute',
                width: 14,
                height: 14,
                top: 2,
                left: 2,
                zIndex: -1
            }
        },
        withoutMargin: {
            marginRight: 0,
            marginLeft: 0
        },
        controlLabel: {
            margin: 0
        }
    }));
const Checkbox_styles = useStyles;
export default Checkbox_styles;
